import React, { useRef, useState, useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import InfoPopUp from "../../Common/InfoPopUp";
import TelegramIcon from "@mui/icons-material/Telegram";

const FUTURESOCKETSTREAMURL =
  "https://futures-stream.paybito.com/fSocketStream/api";

const FutureBuyAndSellMarket = ({
  currencycode,
  basecurrency,
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  getUserTransaction,
  assetpair,
  selelectedMarginWalletBalance,
  selectedLeverageMarginType,
  selectedContractBalance,
  finalbaseLeverage,
  renderAvailableBalance,
}) => {
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const tradep = 6;

  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [onlyBuyAmount, setOnlyBuyAmount] = useState("");
  const [onlyBuyPrice, setOnlyBuyPrice] = useState("");
  const [onlyBuyTotalPrice, setOnlyBuyTotalPrice] = useState();
  const [isDirty, setIsDirty] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [showBuyError, setShowBuyError] = useState();
  const buyButtonRef = useRef(null);

  const [onlySellAmount, setOnlySellAmount] = useState("");
  const [onlySellPrice, setOnlySellPrice] = useState("");
  const [buyDisabled, setBuyDisabled] = useState(true);
  const [sellDisabled, setSellDisabled] = useState(true);

  const [error, setError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [onlySellTotalPrice, setOnlySellTotalPrice] = useState();
  const [sellError, setSellError] = useState(false);
  const [marketSellError, setMarketSellError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    getSellSliderVal(closestStep);
    validateMarketSell();
  };
  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    getBuySliderVal(closestStep);
  };
  const handleClose = () => setShow(false);

  const resetSliderBuy = () => {
    setProgress(0);
  };
  const resetSliderSell = () => {
    setSliderValue(0);
  };

  const handleKeyUp = (event) => {
    setIsDirty(true);
    getBuyVal(event);
    validatemarketbuy();
    resetSliderBuy();
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setOnlyBuyAmount(value);
    setIsInvalid(value === "" || isNaN(value)); // Example validation
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const getBuyVal = (event) => {
    let val = event.target.value;
    setOnlyBuyAmount(val);

    // Reset sliders
    if (progressBarRef.current) {
      progressBarRef.current.value = 0;
    }

    if (val < 0 || val === "") {
      setIsInvalid(true);
      setIsDirty(true);
      setOnlyBuyAmount("");
      return;
    }

    axios
      .get(`${FUTURESOCKETSTREAMURL}/marketPrice`, {
        params: {
          symbol: assetpair,
          side: "BID",
          amount: val,
        },
      })
      .then((response) => {
        const result = response.data;
        if (result.statuscode !== "0") {
          const price = parseFloat(result.price).toFixed(tradep);
          const totalPrice = (
            parseFloat(result.price) * parseFloat(val)
          ).toFixed(tradep);

          setOnlyBuyPrice(price);
          setOnlyBuyTotalPrice(totalPrice);

          if (totalPrice < 0.001) {
            setShowBuyError(true);
            if (buyButtonRef.current) buyButtonRef.current.disabled = true;
          } else {
            setShowBuyError(false);
            if (buyButtonRef.current) buyButtonRef.current.disabled = false;
          }
        } else {
          setOnlyBuyPrice(0);
          setOnlyBuyTotalPrice(0);
          // setShowBuyError(true);
          if (buyButtonRef.current) buyButtonRef.current.disabled = true;
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            //logout
          }
        }
      });
  };

  const validatemarketbuy = () => {
    if (onlyBuyAmount <= 0.0001) {
      // document.getElementById("marketbuy").disabled = true;
    } else {
      // document.getElementById("marketbuy").disabled = false;
    }
  };

  const handleAmountFromTotalPrice = async (e, type) => {
    let inputValue = e.target.value;
    let balance = parseFloat(selectedSellingAssetBalance);

    // Reset slider values (assuming state management for sliders)

    if (inputValue !== "") {
      if (parseFloat(inputValue) <= balance) {
        try {
          const response = await axios.get(`${FUTURESOCKETSTREAMURL}/depth`, {
            params: { symbol: assetpair, limit: 1 },
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          });
          const depthData = response.data;

          if (type === "buy") {
            let onlyBuyPrice = parseFloat(depthData.ask[0].price).toFixed(
              tradep
            );
            let onlyBuyAmount = (
              parseFloat(inputValue) / parseFloat(depthData.ask[0].price)
            ).toFixed(tradep);

            setOnlyBuyPrice(onlyBuyPrice);
            setOnlyBuyAmount(onlyBuyAmount);
            setOnlyBuyTotalPrice(inputValue);
            resetSliderBuy();
          } else {
            let onlySellPrice = parseFloat(depthData.bid[0].price).toFixed(
              tradep
            );
            let onlySellAmount = (
              parseFloat(inputValue) / parseFloat(depthData.bid[0].price)
            ).toFixed(tradep);

            setOnlySellPrice(onlySellPrice);
            setOnlySellAmount(onlySellAmount);
            setOnlySellTotalPrice(inputValue);
            resetSliderSell();
          }
        } catch (error) {
          console.error("Error fetching depth data:", error);
        }
      } else {
        showToast("error", "Total Price is exceeding your current balance");
      }
    } else {
      if (type === "buy") {
        setOnlyBuyPrice("");
        setOnlyBuyAmount("");
        setOnlyBuyTotalPrice("");
        setProgress(0);
      } else {
        setOnlySellPrice("");
        setOnlySellAmount("");
        setOnlySellTotalPrice("");
        setSliderValue(0);
      }
    }
  };

  const getBuySliderVal = async (sliderValue) => {
    try {
      const response = await axios.get(`${FUTURESOCKETSTREAMURL}/depth`, {
        params: {
          symbol: assetpair,
          limit: 1,
        },
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      });

      let marketPrice = parseFloat(response.data.ask[0].price);
      let mwb = parseFloat(selelectedMarginWalletBalance);
      let leverage = finalbaseLeverage;

      let calculatedAmount = (
        ((mwb * (sliderValue / 100) -
          mwb * leverage * (sliderValue / 100) * percentageValue) *
          leverage) /
        marketPrice
      ).toFixed(tradep);
      console.log("marketPrice", marketPrice, mwb, leverage, calculatedAmount);
      setOnlyBuyAmount(calculatedAmount);

      getBuyValSlider(calculatedAmount);
      validatemarketbuy();
    } catch (error) {
      console.error("Error fetching market data", error);
    }
  };

  const getBuyValSlider = async (val) => {
    if (val < 0 || val === "") {
      if (val === 0) {
        setOnlyBuyPrice(0);
        setOnlyBuyTotalPrice(0);
      }
      showToast("error", "Amount cannot be negative or blank");
      setOnlyBuyAmount("");
      return;
    }

    try {
      const response = await axios.get(`${FUTURESOCKETSTREAMURL}/marketPrice`, {
        params: {
          symbol: assetpair,
          side: "BID",
          amount: val,
        },
      });

      const result = response.data;
      if (result.statuscode !== 0) {
        const price = parseFloat(result.price).toFixed(tradep);
        const totalPrice = (parseFloat(result.price) * parseFloat(val)).toFixed(
          tradep
        );
        setOnlyBuyPrice(price);
        setOnlyBuyTotalPrice(totalPrice);
      } else {
        setOnlyBuyPrice(0);
        setOnlyBuyTotalPrice(0);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        //logout
      }
    }
  };

  const getAssetCode = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset ? asset.assetCode : "";
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return "";
    }
  };

  /* Get base and counter ID of a pair */
  const getAssetId = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset
        ? { baseCurrencyId: asset.baseCurrencyId, currencyId: asset.currencyId }
        : {};
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return {};
    }
  };

  const marketBuy = async () => {
    setIsLoading(false);
    const inputObj = {
      selling_asset_code: basecurrency.toUpperCase(),
      buying_asset_code: currencycode.toUpperCase(),
      amount: parseFloat(onlyBuyAmount),
      price: onlyBuyPrice,
      offerType: "M",
      txn_type: "1",
      assetPair: assetpair,
      leverage:
        localStorage.getItem("selected_leverage_future")?.slice(0, -1) || 2,
      uuid: localStorage.getItem("uuid"),
    };

    if (parseInt(inputObj.leverage) > 1) {
      inputObj.marginType = selectedLeverageMarginType;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}fTrade/TradeCreateOffer`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response?.data?.error?.error_data !== 0) {
        if (response?.data?.error?.error_data === 1) {
          showToast("error", response?.data?.error?.error_msg);
        } else {
          //   document.getElementById('warn').click();
        }
        setIsLoading(false);
      } else {
        reset();
        showToast("success", response?.data?.error?.error_msg);
        resetSliderBuy();
        setIsLoading(false);
        // renderDataForMyTradeFutures();
        // renderDataForMyOfferFutures();
      }

      if (finalbaseLeverage > 1) {
        renderAvailableBalance();
      } else {
        getUserTransaction();
      }
    } catch (error) {
      setIsLoading(false);
      //   document.querySelectorAll('.onlyBuyBtn, .onlySellBtn').forEach(btn => btn.disabled = false);
      console.error("Error placing market buy order:", error);
      showToast("error", "Error processing the order");
    }
  };

  const reset = () => {
    setOnlyBuyAmount("");
    setOnlyBuyPrice("");
    setProgress(0);
    setOnlyBuyTotalPrice("");
  };

  const getSellVal = async (event) => {
    let val = event.target.value;

    // Reset sliders (assuming they're in state)
    setOnlySellAmount(val);
    resetSliderSell();

    if (val < 0 || val === "") {
      showToast("warning", "Amount cannot be negative or blank");
      setOnlySellAmount("");
      return;
    }

    try {
      const { data: result } = await axios.get(
        `${FUTURESOCKETSTREAMURL}/marketPrice?symbol=${assetpair}&side=ASK&amount=${val}`
      );

      if (result.statuscode !== 0) {
        const price = parseFloat(result.price).toFixed(tradep);
        const totalPrice = (parseFloat(result.price) * parseFloat(val)).toFixed(
          tradep
        );

        setOnlySellPrice(price);
        setOnlySellTotalPrice(totalPrice);
        setSellError(totalPrice < 0.001);
      } else {
        setOnlySellPrice(0);
        setOnlySellTotalPrice(0);
        setSellError(true);
      }
    } catch (error) {
      console.error("Error fetching sell price:", error);
    }
  };
  const validateMarketSell = () => {
    if (parseFloat(onlySellAmount) <= 0.0001) {
      setMarketSellError(true);
      return true;
    } else {
      setMarketSellError(false);
      return false;
    }
  };

  //   const getSellValSlider = async (amount) => {
  //     if (amount < 0 || amount === "") {
  //       if (amount === 0) {
  //         setOnlySellPrice(0);
  //         setOnlySellTotalPrice(0);
  //       }
  //       showToast("warning", "Amount cannot be negative or blank");
  //       setOnlySellAmount("");
  //       return;
  //     }

  //     try {
  //       const response = await fetch(
  //         `https://stream.paybito.com/SocketStream/api/marketPrice?symbol=${currencycode?.toUpperCase()}${basecurrency?.toUpperCase()}&side=ASK&amount=${amount}`
  //       );
  //       const result = await response.json();

  //       if (result.statuscode !== 0) {
  //         let price = parseFloat(result.price).toFixed(tradep);
  //         let totalPrice = (
  //           parseFloat(result.price) * parseFloat(amount)
  //         ).toFixed(tradep);
  //         setOnlySellPrice(price);
  //         setOnlySellTotalPrice(totalPrice);
  //         // showToast("error", result?.message)
  //       } else {
  //         setOnlySellPrice(0);
  //         setOnlySellTotalPrice(0);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching trade data:", error);
  //     }
  //   };

  const getSellSliderVal = async (updatedSliderValue) => {
    const mwb = parseFloat(selelectedMarginWalletBalance);
    const leverage = finalbaseLeverage;

    try {
      const response = await axios.get(
        `${FUTURESOCKETSTREAMURL}/depth?symbol=${assetpair}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const marketPrice = parseFloat(response.data.bid[0].price);
      const calculatedSellAmount = (
        ((mwb * (updatedSliderValue / 100) -
          mwb * leverage * (updatedSliderValue / 100) * percentageValue) *
          leverage) /
        marketPrice
      ).toFixed(tradep);
      setOnlySellAmount(calculatedSellAmount);
      getSellValSlider(calculatedSellAmount);
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const getSellValSlider = async (val) => {
    if (val < 0 || val === "") {
      if (val === 0) {
        setOnlySellPrice(0);
        setOnlySellTotalPrice(0);
      }
      showToast("warning", "Amount cannot be negative or blank");
      setOnlySellAmount("");
      return;
    }

    try {
      const response = await axios.get(
        `${FUTURESOCKETSTREAMURL}/marketPrice?symbol=${assetpair}&side=ASK&amount=${val}`
      );
      const result = response.data;

      if (result.statuscode !== 0) {
        const price = parseFloat(result.price).toFixed(tradep);
        const totalPrice = (parseFloat(result.price) * parseFloat(val)).toFixed(
          tradep
        );
        setOnlySellPrice(price);
        setOnlySellTotalPrice(totalPrice);

        if (totalPrice < 0.001) {
          setSellError(true);
        } else {
          setSellError(false);
        }
      } else {
        setOnlySellPrice(0);
        setOnlySellTotalPrice(0);
        setSellError(true);
      }
    } catch (error) {
      console.error("Error fetching market price:", error);
    }
  };

  const marketSell = async () => {
    setLoading(true);
    // data.alert("Loading...", "dark");

    const inputObj = {
      selling_asset_code: currencycode?.toUpperCase(),
      buying_asset_code: basecurrency?.toUpperCase(),
      amount: parseFloat(onlySellAmount),
      price: parseFloat(onlySellPrice),
      offerType: "M",
      txn_type: "2",
      assetPair: assetpair,
      leverage: finalbaseLeverage,
      uuid: localStorage.getItem("uuid"),
    };

    if (parseInt(inputObj.leverage) > 1) {
      inputObj.marginType = selectedLeverageMarginType;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}fTrade/TradeCreateOffer`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        if (result.error.error_data === 1) {
          showToast("error", response.data.error.error_msg);
        } else {
          //   document.getElementById("warn").click();
        }
        setLoading(false);
      } else {
        resetSell();
        showToast("success", result.error.error_msg);
        setLoading(false);
        // renderDataForMyTradeFutures();
        // renderDataForMyOfferFutures();
      }

      if (parseInt(inputObj.leverage) > 1) {
        renderAvailableBalance();
      } else {
        getUserTransaction();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error placing market sell order", error);
    }
  };

  const resetSell = () => {
    setSliderValue(0);
    setOnlySellAmount("");
    setOnlySellPrice("");
    setOnlySellTotalPrice("");
  };

  const checkNumber = (num) => (isNaN(num) ? 0 : num);

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY PANEL ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">Buy {currencycode?.toUpperCase()}</div>

          <div className="trade-bal-row">
            <span className="bal-amount">{selectedSellingAssetBalance} {basecurrency?.toUpperCase()}</span>
            <span className="bal-actions">
              <span className="deposit-withdraw-btn" style={{ position: "relative" }}>
                {basecurrency?.toUpperCase() === "USD" ? <span className="diposit-hover">DEPOSIT</span> : <span className="diposit-hover">RECEIVE</span>}
                <TelegramIcon style={{ transform: "rotate(-90deg)", cursor: "pointer", width: 16, height: 16, opacity: 0.55 }} onClick={() => navigate("/my-wallet")} />
              </span>
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input type="number" placeholder="0.00" value={onlyBuyAmount} onChange={handleChange} onKeyUp={handleKeyUp} />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input type="number" placeholder="0.00" value={checkNumber(onlyBuyPrice)} readOnly />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input type="number" placeholder="0.00" value={checkNumber(onlyBuyTotalPrice)} onChange={(e) => handleAmountFromTotalPrice(e, "buy")} />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={progressBarRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${progress === pct ? "pct-active-buy" : ""}`}
                onClick={() => { setProgress(pct); getBuySliderVal(pct); }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-buy"
            disabled={!(onlyBuyTotalPrice > 0 && onlyBuyAmount > 0) || isLoading}
            onClick={marketBuy}
          >
            {isLoading ? "Loading..." : `BUY ${currencycode?.toUpperCase()}`}
          </button>
        </div>

        {/* ── SELL PANEL ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">Sell {currencycode?.toUpperCase()}</div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedContractBalance} {finalbaseLeverage === 1 ? currencycode?.toUpperCase() : basecurrency?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span className="deposit-withdraw-btn" style={{ position: "relative" }}>
                {basecurrency?.toUpperCase() === "USD" ? <span className="diposit-hover">DEPOSIT</span> : <span className="diposit-hover">RECEIVE</span>}
                <TelegramIcon style={{ transform: "rotate(-90deg)", cursor: "pointer", width: 16, height: 16, opacity: 0.55 }} onClick={() => navigate("/my-wallet")} />
              </span>
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input type="number" placeholder="0.00" value={onlySellAmount} onChange={getSellVal} onKeyUp={validateMarketSell} />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input type="number" placeholder="0.00" value={checkNumber(onlySellPrice)} readOnly />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input type="number" placeholder="0.00" value={checkNumber(onlySellTotalPrice)} onChange={(event) => handleAmountFromTotalPrice(event, "sell")} />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={sliderRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${sliderValue === pct ? "pct-active-sell" : ""}`}
                onClick={() => {
                  setSliderValue(pct);
                  getSellSliderVal(pct);
                  validateMarketSell();
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-sell"
            disabled={!(onlySellTotalPrice > 0 && onlySellAmount > 0) || loading}
            onClick={marketSell}
          >
            {loading ? "Loading..." : `SELL ${currencycode?.toUpperCase()}`}
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={"Market"}
        description={`Users can Buy and Sell in the current market price. Enter "Buying Amount" and click on BUY to place a BUY Market order. Enter "Selling Amount" and click on SELL to place a SELL Market order.`}
      />
    </div>
  );
};

export default FutureBuyAndSellMarket;
